import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';

import { APP_NAME } from '../../../constants';
import { PATH } from '../../../constants/path';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import UnsubscribeFormComponent from './UnsubscribeFormComponent';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import { UnsubscribePageContainer } from './UnsubscribePageStyle';
import { getI18nByApp } from '../../../services/i18n/selector';

export class UnsubscribePage extends React.Component {
    render() {
        const { i18n } = this.props;

        return (
            <UnsubscribePageContainer className="conteneur conteneur-mobile">
                <HeadComponent
                    title={getI18nByApp(i18n, 'page.UNSUBSCRIBE.TITLE')}
                    description={getI18nByApp(i18n, 'page.UNSUBSCRIBE.DESCRIPTION')}
                />
                <LocalizedBreadcrumbItem to={PATH.UNSUBSCRIBE_PATH}>
                    {getI18nByApp(i18n, 'page.UNSUBSCRIBE.BREADCRUMB')}
                </LocalizedBreadcrumbItem>
                <h1>{getI18nByApp(i18n, 'page.UNSUBSCRIBE.PAGE_TITLE')}</h1>
                <h3>{format(getI18nByApp(i18n, 'page.UNSUBSCRIBE.SUBTITLE'), APP_NAME)}</h3>
                <p>{format(getI18nByApp(i18n, 'page.UNSUBSCRIBE.MSG_CONFIRMATION'), APP_NAME)}</p>
                <UnsubscribeFormComponent />
            </UnsubscribePageContainer>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n
    };
};

export default withTemplate(connect(mapStateToProps)(UnsubscribePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/unsubscribe/UnsubscribePage.js